const assetStoreKey = {
  all: ['assetStore'] as const,
  getAssetAvatarList: () => [...assetStoreKey.all, 'avatarList'] as const,
  getAssetMotionList: () => [...assetStoreKey.all, 'motionList'] as const,
} as const;

export default assetStoreKey;
